import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

// Emits a Google Analytics 4 `page_view` event on every SPA route change.
// gtag itself is loaded conditionally from index.html (only on carsaledoc.com)
// so this hook is effectively a no-op everywhere else.
//
// We also fire a tiny POST to our backend so the admin funnel can show
// real Visit counts — independent of GA4. Public marketing pages only;
// wizard/admin/sign routes are filtered server-side.
export default function Analytics() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === "undefined") return;
    const path = location.pathname + location.search;
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
    // Backend tracker — fire and forget.
    api.trackPageview(location.pathname);
  }, [location.pathname, location.search]);
  return null;
}
